import { api } from '@/api/ApiGateway'

class OrganizationRolesApi
{
	getRoles(p_on_complete)
	{
		api.get('organization-roles/roles').then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, true)
				return
			}
			try
			{
				p_on_complete(p_response, false)
			}
			catch (e)
			{
				p_response.overrideError({ detail: `${e}` })
				p_on_complete(p_response, true)
			}
		})
	}

	getRole(p_role_id, p_on_complete)
	{
		api.get('organization-roles/role/' + p_role_id).then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, true)
				return
			}
			try
			{
				p_on_complete(p_response, false)
			}
			catch (e)
			{
				p_response.overrideError({ detail: `${e}` })
				p_on_complete(p_response, true)
			}
		})
	}

	saveRole(p_roles, p_on_complete)
	{
		api.post('organization-roles/save/', p_roles).then(p_response =>
		{
			if (p_response.hasError())
			{
				p_on_complete(p_response, true)
				return
			}
			try
			{
				p_on_complete(p_response, false)
			}
			catch (e)
			{
				p_response.overrideError({ detail: `${e}` })
				p_on_complete(p_response, true)
			}
		})
	}


}

export const organizationRolesApi = new OrganizationRolesApi()